import { Navigate, Route, Routes } from 'react-router-dom'

import { appLink } from '@app/config/appLink'
import BaseLayout from '@app/layout/BaseLayout'
import PublicRiskStoryLayout from '../components/Risk/layout/PublicRiskStoryLayout'
import { RiskStoryDetail } from '../components/Risk/Story/RiskStoryDetail'
import RiskStoryLandingPage from '../components/Risk/Story/RiskStoryLandingPage'
import RiskStorySummaryPage from '../components/Risk/Story/RiskStorySummaryPage'
import { ErrorPage } from './ErrorPage'

import MarketingRoutes from '@web/routes/marketing.routes'
import AppRoutes from './app.routes'
import GuideRoutes from './guide.routes'
import HomeRoutes from './home.routes'
import RiskRoutes from './risk.routes'

export const RexRoutes = () => {
  return (
    <Routes>
      {/* ================================================= */}
      {/* TEMPORARY LEGACY APP URL REDIRECTS (REMOVE LATER) */}
      {/* ================================================= */}

      <Route path="/home/*" element={<Navigate to="/app/home" replace />} />
      <Route path="/guide/*" element={<Navigate to="/app/guide" replace />} />
      <Route path="/risk/*" element={<Navigate to="/app/risk" replace />} />
      <Route path="/property/*" element={<Navigate to={appLink.property.path} replace />} />
      <Route
        path="/prioritisation/*"
        element={<Navigate to="/app/risk/prioritisation" replace />}
      />
      <Route path="/admin/*" element={<Navigate to="/app/admin/manage-users" replace />} />

      {/* Risk legacy (exclude public views) */}
      <Route path="/risk/overview" element={<Navigate to="/app/risk/overview" replace />} />
      <Route path="/risk/explorer" element={<Navigate to="/app/risk/explorer" replace />} />
      <Route path="/risk/summary" element={<Navigate to="/app/risk/summary" replace />} />
      <Route
        path="/risk/prioritisation/*"
        element={<Navigate to="/app/risk/prioritisation" replace />}
      />

      {/* ============================== */}
      {/* PUBLIC ROUTES (NO AUTH)        */}
      {/* ============================== */}

      <Route element={<PublicRiskStoryLayout />}>
        <Route path="/risk/stories/:storyId/:slug/view" element={<RiskStoryLandingPage />} />
        <Route
          path="/risk/stories/:storyId/:slug/view/summary"
          element={<RiskStorySummaryPage />}
        />
        <Route
          path="/risk/stories/:storyId/:slug/view/chapters"
          element={<RiskStoryDetail publicView />}
        />
      </Route>

      {/* ============================== */}
      {/* MARKETING WEBSITE              */}
      {/* ============================== */}

      {MarketingRoutes()}

      {/* ============================== */}
      {/* APPLICATION SPA                */}
      {/* ============================== */}

      <Route path="/app" element={<BaseLayout />}>
        <Route index element={<Navigate to="/app/home/welcome" replace />} />
        {HomeRoutes()}
        {GuideRoutes()}
        {RiskRoutes()}

        {/* small modules routes */}
        {AppRoutes()}
      </Route>

      {/* ============================== */}
      {/* GLOBAL FALLBACK                */}
      {/* ============================== */}

      <Route path="/map" element={<Navigate to="/app/risk" replace />} />
      <Route path="/explorer/*" element={<Navigate to="/" replace />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  )
}
